/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Image, Link } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'

// TODO Set the correct article ID here
const ARTICLE_ID = '535233431708'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Der unglaubliche Effekt von Impfungen an fünf Beispielen</h1>
            <h2>
              Impfungen sind die bedeutendste Errungenschaft in der
              Medizingeschichte. Diese Grafiken zeigen, wie sie in der Schweiz
              und weltweit zur Ausrottung gefährlicher Infektionskrankheiten
              geführt haben.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Yannick Wiget, Patrick Vögeli</div>
            <div className='ta updated'>Aktualisiert am 24. Juni 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Wer seine Ehepartnerin oder seinen Ehepartner verloren hat, ist
              Witwer oder Witwe. Wer seine Eltern verloren hat, wird als Waise
              bezeichnet. Für Eltern, die den Verlust ihres Kindes beklagen,
              gibt es aber keinen Ausdruck. Jahrhundertelang war die
              Kindersterblichkeit auch in der Schweiz hoch: 1876, zu Beginn der
              Statistik der Todesfälle, starben laut der Informationsplattform{' '}
              <Link href='https://www.infovac.ch/de/faq/epidemien'>
                Infovac
              </Link>{' '}
              ungefähr 200 von 1000 Babys – heute sind es nur noch etwa 3,5 von
              1000.
            </p>
            <p>
              Dieser spektakuläre Fortschritt ist zu einem grossen Teil
              verschiedenen Impfungen zu verdanken, wie im Folgenden aufgezeigt
              wird. Denn wenn eine Bevölkerung gegen den Erreger (Virus oder
              Bakterium) einer ansteckenden Krankheit – mehr oder weniger –
              durchgeimpft ist, profitiert sie von einer Herdenimmunität: Selbst
              wenn eine Person infiziert ist, kann sich die Ansteckung nicht
              ausbreiten, weil ihr Umfeld bereits immunisiert ist. Dadurch sind
              auch Neugeborene geschützt und andere Personen, die nicht geimpft
              werden können.
            </p>
            <p>
              Diese fünf Beispiele zeigen, wie Impfungen in der Schweiz und
              weltweit zum Rückgang oder gar zur Eliminierung von gefährlichen
              Infektionskrankheiten geführt haben:
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <h4 className='chapter'>
                <b>1</b>
                <br />
                Ausrottung der Kinderlähmung in der Schweiz
              </h4>
              <p>
                <Link href='https://www.bag.admin.ch/bag/de/home/krankheiten/krankheiten-im-ueberblick/polio.html'>
                  Poliomyelitis
                </Link>{' '}
                ist eine hochansteckende Krankheit, die durch Polioviren
                ausgelöst und meist über Schmierinfektionen durch schmutzige
                Hände, kontaminiertes Wasser oder Lebensmittel übertragen wird.
                Viele Infektionen verlaufen ohne Symptome, mit grippeartigen
                Beschwerden oder Magen-Darm-Problemen. In seltenen Fällen kommt
                es aber zu Lähmungen der Beine und Arme oder gar zu einer
                Atemlähmung, die Langzeitschäden verursachen oder zum Tod führen
                kann.
              </p>
              <p>
                Anfang des 20. Jahrhunderts waren vor allem Kleinkinder davon
                betroffen, bei denen die Infektion meist asymptomatisch verlief.
                Durch bessere hygienische Verhältnisse stiegen das
                Ansteckungssalter und die daraus folgenden Komplikationen. So
                erklärt sich die steigende Inzidenz in den 40er- und
                50er-Jahren. Dann kam 1957 die Impfung gegen die Kinderlähmung
                und drückte die Zahlen stark nach unten.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui container'>
            <div className='ui two column grid doubling stackable'>
              <div className='row'>
                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      Polio-Neuansteckungen in der Schweiz, 1913–1982
                    </h4>
                    <div className='graphicSub'>
                      <div>pro 100'000 Einwohner</div>
                      {/* <div style={{ marginTop: '0.5rem' }}>
                        <span className='bold'>Lesebeispiel:</span> 2020 gab es
                        fast doppelt so viele Hühner in der Schweiz wie im
                        Referenzjahr 1975.
                      </div> */}
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/bAlWK/'
                          style={{ height: '350px' }}
                        />
                      </div>
                      <div className='source'>
                        Grafik: pvo / Quelle: Historische Statistik Schweiz,
                        Bundesamt für Statistik
                      </div>
                    </div>
                  </div>
                </div>

                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      Polio-Todesfälle in der Schweiz, 1901–1981
                    </h4>
                    <div className='graphicSub'>
                      <div>pro 100'000 Einwohner</div>
                      {/* <div style={{ marginTop: '0.5rem' }}>
                        <span className='bold'>Lesebeispiel:</span> 2020 gab es
                        fast doppelt so viele Hühner in der Schweiz wie im
                        Referenzjahr 1975.
                      </div> */}
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/RLwC9/'
                          style={{ height: '350px' }}
                        />
                      </div>
                      <div className='source'>
                        Grafik: pvo / Quelle: Historische Statistik Schweiz,
                        Bundesamt für Statistik
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                In den 50er-Jahren gab es noch mehrere Hundert, teils über 1000
                Fälle pro Jahr. Nicht einmal zehn Jahre nach Einführung der
                Impfung waren es fast keine mehr. «Die Kinderlähmung ist das
                Paradebeispiel der erfolgreichen neueren Impfung», sagt Hubert
                Steinke vom Institut für Medizingeschichte der Universität Bern.
                «Natürlich haben auch Hygienemassnahmen Ansteckungen verhindert,
                aber ohne Impfungen wäre diese ansteckende Krankheit sicher
                nicht verschwunden.»
              </p>
              <p>
                Der letzte Fall von Kinderlähmung wurde in der Schweiz 1982
                gemeldet, der letzte Todesfall 1981, also vor 40 Jahren. Ohne
                Impfung starben jährlich noch mehrere Dutzend Kinder an Polio.
                Auf dem Höhepunkt 1944 waren es sogar über 200.
              </p>
              <p>
                1988 beschloss die Weltgesundheitsorganisation WHO, die
                Kinderlähmung weltweit auszurotten. Dieses Ziel ist nah, aber
                noch nicht erreicht. Heute gelten Amerika, Europa und der
                Westpazifik als Polio-frei. In WHO-Regionen mit tiefer
                Durchimpfungsrate zirkulieren die Viren aber noch. Denn eine
                Impfung ist die einzige Möglichkeit, sich vor dieser Krankheit
                zu schützen.
              </p>
              <p>
                Weil fortwährend das Risiko besteht, dass das Virus wieder
                eingeschleppt wird, muss auch in Polio-freien Ländern weiterhin
                dagegen geimpft werden. In der Schweiz erhalten Kinder insgesamt
                vier Dosen, drei im ersten Lebensjahr und eine weitere zwischen
                4 und 7 Jahren.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <h4 className='chapter'>
                <b>2</b>
                <br />
                Ausrottung der Rachendiphtherie in der Schweiz
              </h4>
              <p>
                Auch die{' '}
                <Link href='https://www.bag.admin.ch/bag/de/home/krankheiten/krankheiten-im-ueberblick/diphtherie.html'>
                  Diphtherie
                </Link>{' '}
                wurde hierzulande in den 80er-Jahren so gut wie eliminiert. Es
                handelt sich um eine Infektionskrankheit, die durch Bakterien
                verursacht wird, die weltweit verbreitet sind. Der Erreger
                befällt primär die oberen Atemwege und produziert ein starkes
                Gift, das Organe wie Herz und Leber dauerhaft schädigt.
                Besonders gefährdet für einen tödlichen Ausgang der Erkrankung
                sind ungeimpfte Kleinkinder und ältere Menschen.
              </p>
              <p>
                Man unterscheidet zwei Arten: die respiratorische (Rachen-) und
                die kutane (Haut-)Diphtherie. Letztere ist weniger
                lebensbedrohlich. Durch die Erfindung eines Gegengifts zu Beginn
                des 20. Jahrhunderts konnte die hohe Sterblichkeitsrate von 50
                Prozent bei Rachendiphtherie gesenkt werden. Aber erst die
                Einführung der Impfung um 1930 und die konsequente Durchführung
                derselben ab Ende der 1940er-Jahre brachte die Zahlen nachhaltig
                runter. Der letzte Todesfall durch Rachendiphtherie trat in der
                Schweiz 1980 auf. Danach gab es noch drei Opfer durch
                Hautdiphtherie.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui container'>
            <div className='ui two column grid doubling stackable'>
              <div className='row'>
                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      Diphtherie-Neuansteckungen in der Schweiz, 1895–1983
                    </h4>
                    <div className='graphicSub'>
                      <div>pro 100'000 Einwohner</div>
                      {/* <div style={{ marginTop: '0.5rem' }}>
                        <span className='bold'>Lesebeispiel:</span> 2020 gab es
                        fast doppelt so viele Hühner in der Schweiz wie im
                        Referenzjahr 1975.
                      </div> */}
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/KIlVx/'
                          style={{ height: '350px' }}
                        />
                      </div>
                      <div className='source'>
                        Grafik: pvo / Quelle: Historische Statistik Schweiz,
                        Bundesamt für Statistik
                      </div>
                    </div>
                  </div>
                </div>

                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      Diphtherie-Todesfälle in der Schweiz, 1876–1993
                    </h4>
                    <div className='graphicSub'>
                      <div>pro 100'000 Einwohner</div>
                      {/* <div style={{ marginTop: '0.5rem' }}>
                        <span className='bold'>Lesebeispiel:</span> 2020 gab es
                        fast doppelt so viele Hühner in der Schweiz wie im
                        Referenzjahr 1975.
                      </div> */}
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/OnaD0/'
                          style={{ height: '350px' }}
                        />
                      </div>
                      <div className='source'>
                        Grafik: pvo / Quelle: Historische Statistik Schweiz,
                        Bundesamt für Statistik
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Während des Zweiten Weltkrieges kam es nochmals zu einer
                Epidemie, die grosse Teile Europas inklusive der Schweiz betraf.
                Der Einsatz von Antibiotika ab Mitte der 40er-Jahre spielte eine
                wichtige Rolle beim anschliessenden Rückgang der Zahlen. Seither
                kann das Diphtheriebakterium mit einer antibiotischen Therapie
                bekämpft werden, was ebenfalls zum Rückgang der Mortalität
                beitrug. «Die Impfung hat aber geholfen, die Ansteckungszahlen
                tief zu halten, und so erneute Ausbrüche verhindert», sagt
                Medizinhistoriker Steinke. In der Schweiz infizierte sich
                letztmals 1983 jemand mit Rachendiphtherie. Fälle von
                Hautdiphtherie gibt es nur noch vereinzelt.
              </p>
              <p>
                In Regionen mit tiefer Durchimpfung wie Afrika, Asien,
                Lateinamerika und Osteuropa kommt die Krankheit immer noch
                verbreitet vor. Die Übertragung von Mensch zu Mensch erfolgt
                über Tröpfcheninfektion beim Husten und Niesen. Seltener zu
                einer Ansteckung kommt es über verunreinigte Gegenstände oder
                bei der Hautdiphtherie durch direkten Kontakt.
              </p>
              <p>
                Der Impfstoff gewährleistet laut{' '}
                <Link href='https://www.infovac.ch/de/impfunge/nach-krankheiten-geordnet/diphtherie'>
                  Infovac
                </Link>{' '}
                einen Schutz von etwa 90 Prozent. Es handelt sich um einen
                sogenannten Kombinationsimpfstoff, der neben Diphtherie auch vor
                Keuchhusten, Tetanus und oft auch Kinderlähmung und Hepatitis B
                schützt. Der Schutz hält allerdings nicht sehr lange an, weshalb
                regelmässige Auffrischungsimpfungen erforderlich sind.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <h4 className='chapter'>
                <b>3</b>
                <br />
                Eindämmung der Masern in der Schweiz
              </h4>
              <p>
                Lange waren die{' '}
                <Link href='https://www.bag.admin.ch/bag/de/home/krankheiten/krankheiten-im-ueberblick/masern.html'>
                  Masern
                </Link>{' '}
                eine Krankheit, mit der sich fast alle Kinder infizierten. Das
                hochansteckende Virus wird durch Tröpfcheninfektion beim Husten
                oder Niesen übertragen. Es führt häufig zu Komplikationen wie
                etwa einer Art Amnesie des Immunsystems, die Gedächtniszellen
                zerstört und Patienten wieder anfällig für Krankheiten macht,
                die sie bereits hatten. Die Masern können aber auch zu einer
                Mittelohrentzündung, Lungenentzündung, Hirnentzündung oder im
                schlimmsten Fall zum Tod führen.
              </p>
              <p>
                Zwar war die Zahl der Masernopfer in der Schweiz dank besserer
                Behandlungsmethoden schon vor Einführung der Impfung im Jahr
                1964 rückläufig. «Aber die Impfung hat geholfen, den Rückgang zu
                konsolidieren und beinahe für das Verschwinden von Todesfällen
                gesorgt», sagt Flurin Condrau, Medizinhistoriker an der
                Universität Zürich.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui container'>
            <div className='ui two column grid doubling stackable'>
              <div className='row'>
                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      Masern-Neuansteckungen in der Schweiz, 1987–2020
                    </h4>
                    <div className='graphicSub'>
                      <div>pro 100'000 Einwohner</div>
                      {/* <div style={{ marginTop: '0.5rem' }}>
                        <span className='bold'>Lesebeispiel:</span> 2020 gab es
                        fast doppelt so viele Hühner in der Schweiz wie im
                        Referenzjahr 1975.
                      </div> */}
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/L4Qnm/'
                          style={{ height: '350px' }}
                        />
                      </div>
                      <div className='source twoLine'>
                        Grafik: pvo / Quelle: Bundesamt für Gesundheit
                      </div>
                    </div>
                  </div>
                </div>

                <div className='column special'>
                  <div className='titleBox'>
                    <h4 className='graphicTitle'>
                      Masern-Todesfälle in der Schweiz, 1876–2020
                    </h4>
                    <div className='graphicSub'>
                      <div>pro 100'000 Einwohner</div>
                      {/* <div style={{ marginTop: '0.5rem' }}>
                        <span className='bold'>Lesebeispiel:</span> 2020 gab es
                        fast doppelt so viele Hühner in der Schweiz wie im
                        Referenzjahr 1975.
                      </div> */}
                    </div>
                  </div>
                  <div className='graphicBox'>
                    <div className='boxWrapper'>
                      <div className='iframeBox'>
                        <AutofitIFrame
                          src='//datawrapper.dwcdn.net/WuOq3/'
                          style={{ height: '350px' }}
                        />
                      </div>
                      <div className='source'>
                        Grafik: pvo / Quelle: Historische Statistik Schweiz,
                        Bundesamt für Statistik
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                <Link href='https://www.infovac.ch/de/impfunge/nach-krankheiten-geordnet/masern'>
                  Fachleute schätzen
                </Link>
                , dass es ohne Impfung in der Schweiz jedes Jahr zu 40 bis 70
                Gehirnentzündungen und 15 bis 40 Todesfällen kommen würde. Heute
                sind die Masern nicht mehr speziell eine Kinderkrankheit,
                sondern können in jedem Alter auftreten. Todesfälle gibt es nur
                noch selten, aber es gibt sie noch. 2019 starb zum Beispiel ein
                zuvor gesunder 30-jähriger Mann, der nicht geimpft war.
              </p>
              <p>
                Dass die Krankheit nicht ganz verschwunden ist, hat mit der
                Durchimpfungsrate zu tun. Diese muss umso höher sein, je
                ansteckender eine Krankheit ist. Bei der Kinderlähmung und der
                Diphtherie reicht eine Rate von 80 bis 86 Prozent für eine
                Herdenimmunität. Bei den Masern müssten mindestens 95 Prozent
                der Bevölkerung immun sein.
              </p>
              <p>
                In den letzten Jahren ist die Impfrate kontinuierlich gestiegen.
                Bei zweijährigen Kindern liegt sie aber immer noch unter 90
                Prozent. Und viele nach 1963 geborene Erwachsene haben als
                Kinder (teils ohne Wissen) nur eine oder gar keine Dosis
                bekommen. Zwei Dosen einer MMR-Impfung schützen ein Leben lang
                vor den Komplikationen von Masern, Mumps und Röteln.
              </p>
              <p>
                In der Schweiz gibt es folglich immer wieder Masernausbrüche,
                zum Teil auch durch importierte Fälle. Dank der steigenden
                Impfrate werden sie aber kleiner und erfolgen in grösseren
                Abständen als früher. Um die Krankheit nicht nur einzudämmen,
                sondern nachhaltig auszurotten, bräuchte es die besagte
                Durchimpfung von 95 Prozent der Gesamtbevölkerung. Sie kann nur
                durch Aufklärung und Überzeugungsarbeit erreicht werden. Denn
                alle Impfungen in der Schweiz, auch diejenige gegen Masern, sind
                freiwillig. Es gibt keine Impfpflicht, sondern nur eine
                -empfehlung.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <h4 className='chapter'>
                <b>4</b>
                <br />
                Ausrottung der Pocken weltweit
              </h4>{' '}
              <p>
                Die Pocken waren die erste Krankheit, gegen die eine Impfung
                erfunden wurde. 1796 beobachtete der englische Landarzt{' '}
                <Link href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC1200696/'>
                  Edward Jenner
                </Link>
                , dass Menschen, welche die harmlosen Kuhpocken durchgemacht
                hatten, nicht mehr an den Pocken erkrankten. Also infizierte er
                einen achtjährigen Jungen mit Kuhpocken, der sich anschliessend
                tatsächlich als immun gegen gewöhnliche Pocken erwies. Dieses
                Experiment gilt als Beginn der aktiven Immunisierung in der
                Medizin. Jenner nannte sein Verfahren «Vaccination», nach
                «vacca», dem lateinischen Wort für Kuh.
              </p>
              <p>
                Innerhalb weniger Jahre wurde die Pockenimpfung auch in der
                Schweiz und anderen Ländern eingeführt. Schweden etwa startete
                1801 mit der Impfung, was die Zahl der Todesfälle durch Pocken
                schlagartig sinken liess. Vorher war es regelmässig zu starken
                Ausbrüchen mit Tausenden Opfern gekommen. In schlimmen Jahren
                waren die Pocken für ein Viertel aller Todesfälle im Land
                verantwortlich.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className=''>
              <div className='titleBox noBorder'>
                <h4 className='graphicTitle'>
                  Pocken-Todesfälle in Schweden, 1774–1899
                </h4>
                <div className='graphicSub'>
                  <div>pro 100'000 Einwohner</div>
                  {/* <div style={{ marginTop: '0.5rem' }}>
                    <span className='bold'>Lesebeispiel:</span> Im Jahr 2018
                    wurden 293'000 Tonnen Futtermittel importiert
                    (Proteinanteil). Dies entspricht rund 25 Prozent des
                    gesamten Futtermittelbedarfs.
                  </div> */}
                </div>
              </div>
              <div className='graphicBox'>
                <div className='boxWrapper'>
                  <div className='iframeBox inline'>
                    <AutofitIFrame
                      src='//datawrapper.dwcdn.net/Rk23E/'
                      style={{ height: '350px' }}
                    />
                  </div>
                  <div className='source'>
                    Grafik: pvo / Quelle: Our World In Data
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                Schnell ausradieren liessen sich die{' '}
                <Link href='https://www.bag.admin.ch/bag/de/home/krankheiten/krankheiten-im-ueberblick/variola.html'>
                  Pocken
                </Link>{' '}
                aber nicht. Die schwere Infektionskrankheit wurde durch das
                Variolavirus verursacht und war sehr ansteckend. Die Übertragung
                von Mensch zu Mensch erfolgte durch Tröpfchen, direkten Kontakt
                oder kontaminierte Gegenstände. Viele Infizierte hatten einen
                Hautausschlag, der Vernarbungen auf der Haut hinterliess. In
                schwereren Fällen konnten Erblindung, Gehörlosigkeit, Lähmungen,
                Hirnschäden sowie Lungenentzündungen auftreten. Unbehandelt
                verlief die Krankheit in etwa 30 Prozent der Fälle tödlich.
              </p>
              <p>
                Die Pocken gehörten zu den grössten Killern der Geschichte.
                Allein in Europa starben bis zum Ende des 18. Jahrhunderts noch
                bis zu 10 Prozent aller Kleinkinder daran. Jährlich gab es
                Hunderttausende Todesopfer, ein Drittel der Überlebenden
                erblindete. In den letzten hundert Jahren ihrer Existenz hätten
                die Pocken weltweit wohl mindestens eine halbe Milliarde
                Menschen das Leben gekostet, schätzt der Epidemiologe{' '}
                <Link href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2752094/'>
                  Donald Henderson
                </Link>
                .
              </p>
              <p>
                Gegen Pocken gab es kein Heilmittel, nur eine vorbeugende
                Impfung. Und diese war in vielen Ländern lange nicht
                obligatorisch oder gar nicht vorhanden. Erst 1967 schrieb die
                WHO global eine Impfpflicht gegen Pocken vor, um die Krankheit
                endgültig zu eliminieren. Der letzte natürliche Erkrankungsfall
                wurde 1977 in Somalia verzeichnet. Ein Jahr später gab es noch
                eine tödliche Ansteckung an der Medizinischen Fakultät der
                Universität Birmingham.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className=''>
              <div className='titleBox noBorder'>
                <h4 className='graphicTitle'>
                  Pocken-Neuansteckungen weltweit, 1920–1978
                </h4>
                <div className='graphicSub'>
                  <div>pro 100'000 Einwohner</div>
                  {/* <div style={{ marginTop: '0.5rem' }}>
                    <span className='bold'>Lesebeispiel:</span> Im Jahr 2018
                    wurden 293'000 Tonnen Futtermittel importiert
                    (Proteinanteil). Dies entspricht rund 25 Prozent des
                    gesamten Futtermittelbedarfs.
                  </div> */}
                </div>
              </div>
              <div className='graphicBox'>
                <div className='boxWrapper'>
                  <div className='iframeBox inline'>
                    <AutofitIFrame
                      src='//datawrapper.dwcdn.net/l3FHV/'
                      style={{ height: '350px' }}
                    />
                  </div>
                  <div className='source'>
                    Grafik: pvo / Quelle: WHO, HYDE, UN
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                1980 erklärte die WHO die Pocken weltweit für ausgerottet – als
                erste und bisher einzige menschliche Krankheit. Es ist unmöglich
                zu sagen, wie viele Leben dadurch genau gerettet wurden.{' '}
                <Link href='https://www.sciencedirect.com/science/article/pii/S0264410X98801072'>
                  Schätzungen
                </Link>{' '}
                gehen von etwa 5 Millionen pro Jahr aus. Rechnet man das hoch,
                hätte die Pockenimpfung von 1980 bis heute also über 200
                Millionen Todesopfer verhindert.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <h4 className='chapter'>
                <b>5</b>
                <br />
                Rückgang der Kindersterblichkeit weltweit
              </h4>{' '}
              <p>
                Mittlerweile gibt es Vakzine gegen mehr als 20 lebensbedrohliche
                Krankheiten, die durch Viren oder Bakterien ausgelöst werden.
                Sie verhindern laut der{' '}
                <Link href='https://www.who.int/news-room/fact-sheets/detail/immunization-coverage'>
                  WHO
                </Link>{' '}
                jährlich 4 bis 5 Millionen Todesfälle und verhelfen unzähligen
                Menschen zu einem gesünderen und längeren Leben.
              </p>
              <p>
                Vor allem Kleinkinder werden so vor Infektionskrankheiten
                geschützt, die zu schweren Komplikationen und Behinderungen
                führen oder gar tödlich sein können. Weltweit sterben immer
                weniger unter 5-Jährige, in erster Linie dank Impfungen. Denn
                die Zahl der Todesfälle, die dadurch ganz oder teilweise
                verhindert werden können, ist in den letzten 30 Jahren stark
                gesunken.
              </p>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='titleBox noBorder'>
              <h4 className='graphicTitle'>
                Kindersterblichkeit weltweit nach Todesursache, 1990–2017
              </h4>
              <div className='graphicSub'>
                Todesfälle von Kindern unter 5 Jahren in Millionen
              </div>
            </div>
            <div className='splitter'>
              <div className='graphicBox'>
                <Image
                  file={
                    browserCheck.isMobile
                      ? require('../../images/kindersterblichkeit-weltweit-mobile.svg')
                      : require('../../images/kindersterblichkeit-weltweit.svg')
                  }
                  alt='Entwicklung der Kindersterblichkeit weltweit nach Todesursache'
                  className='cbImage'
                  // source='Quelle: Meteo Schweiz'
                />
                <div className='sourceTwo'>
                  Grafik: pvo / Quelle: Our World In Data
                </div>
              </div>
              <div className='graphicLegendContainer'>
                <div className='legendTitle'>Todesursachen</div>
                <div className='graphicLegend'>
                  <div className='section'>
                    <div className='sectionTitle'>
                      Durch Impfstoffe vermeidbar
                    </div>
                    <div className='itemWrapper'>
                      <div>
                        <div className='square petrol-2' />
                      </div>
                      <div className='legendItem'>Tetanus</div>
                    </div>
                    <div className='itemWrapper'>
                      <div>
                        <div className='square petrol-3' />
                      </div>
                      <div className='legendItem'>Keuchhusten (Pertussis)</div>
                    </div>
                    <div className='itemWrapper'>
                      <div>
                        <div className='square petrol-1' />
                      </div>
                      <div className='legendItem'>Masern</div>
                    </div>
                  </div>
                  <div className='section'>
                    <div className='sectionTitle'>
                      Teilweise durch Impfstoffe vermeidbar
                    </div>
                    <div className='itemWrapper'>
                      <div>
                        <div className='square orange-3' />
                      </div>
                      <div className='legendItem'>Hirnhautentzündung</div>
                    </div>
                    <div className='itemWrapper'>
                      <div>
                        <div className='square orange-2' />
                      </div>
                      <div className='legendItem'>Durchfallerkrankungen</div>
                    </div>
                    <div className='itemWrapper'>
                      <div>
                        <div className='square orange-1' />
                      </div>
                      <div className='legendItem'>
                        Akute Atemwegsinfektionen
                      </div>
                    </div>
                  </div>
                  <div className='section'>
                    <div className='sectionTitle'>
                      Nicht durch Impfstoffe vermeidbar
                    </div>
                    <div className='itemWrapper'>
                      <div className='square beige' />
                      <div className='legendItem'>Andere</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <p>
                1990 starben noch 5,5 Millionen Kleinkinder an Krankheiten wie
                Tetanus oder Keuchhusten, gegen die es Impfungen gibt. 2017
                waren es nur noch 1,8 Millionen – zwei Drittel weniger. Und dies
                trotz des Wachstums der Weltbevölkerung. Im gleichen Zeitraum
                ging die Zahl der Todesfälle durch Ursachen, die nicht mit
                Impfungen vermieden werden können, zwar ebenfalls zurück, aber
                viel weniger stark.
              </p>
              <p>
                Vor 40 Jahren hatten erst etwa 20 Prozent der Kinder weltweit
                Zugang zu lebensrettenden Impfungen. Heute beträgt die Abdeckung
                86 Prozent. Die Zahl der Kinder, die durch Polio gelähmt werden,
                konnte so zum Beispiel um 99,9 Prozent reduziert werden.
                «Impfungen sind eines der mächtigsten Werkzeuge in der
                Geschichte der öffentlichen Gesundheit», sagte WHO-Direktor
                Tedros Ghebreyesus kürzlich.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'>
              <blockquote className='quote'>
                <p>
                  «Die Einführung von Impfungen war ein Meilenstein der
                  Medizingeschichte.»
                </p>
                <div className='byline'>
                  Christoph Berger, Präsident der Eidgenössischen Kommission für
                  Impffragen
                </div>
              </blockquote>
              <p>
                Dieser Meinung sind auch Schweizer Fachleute. Laut
                Medizinhistoriker Hubert Steinke haben die Impfungen die Medizin
                «auf eine neue Ebene gebracht». Die Möglichkeit, Krankheiten
                ganz auszurotten, wäre ihm zufolge mit keinem Antibiotikum oder
                anderen Massnahmen möglich gewesen. Christoph Berger, Präsident
                der Eidgenössischen Kommission für Impffragen (EKIF), spricht
                von einem «Meilenstein der Medizingeschichte». Natürlich würden
                beim Rückgang vieler Krankheiten auch die Verbesserung der
                Hygiene, der Ernährung und der allgemeinen Lebensbedingungen
                eine Rolle spielen. «Aber der wichtigste Faktor sind die
                Impfungen», sagt Berger.
              </p>
              <p>
                Diese haben dafür gesorgt, dass sich die Schweizerinnen und
                Schweizer vor vielen Infektionskrankheiten mittlerweile nicht
                mehr oder nur noch bedingt fürchten müssen. Paradoxerweise
                betrachten deshalb einige die Impfungen als hinfällig. In der
                vernetzten Welt von heute können Krankheiten aber schnell
                importiert werden, siehe Corona-Pandemie. Nur eine hohe
                Impfbereitschaft kann solche Szenarien in Zukunft verhindern.
                Steinke kommt deshalb zum Schluss: «Nicht die Medizin macht die
                Limite, sondern Politik und Gesellschaft.»
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text', 'Yannick Wiget'],
          ['Umsetzung und Grafiken', 'Patrick Vögeli']
        ]}
      />
    </div>
  )
}
